import creditEngineRepository, {CreditEngineRepository} from "@/repositories/creditengine/CreditEngineRepository";

const resource = "/datatable";
export default {
  bulkUploadRows(dataTableBulkUploadRequest) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(
        `${resource}/bulkupload`,
        dataTableBulkUploadRequest
    );
  }
}